import React from 'react';
import PropTypes from 'prop-types';

export default class BookerSetupSuccess extends React.Component {
  componentDidMount() {
    // Fetch text number
    this.props.getTextNumber();
  }

  render() {
    const { business, softwares, onDone } = this.props;
    const { requestStatusMessage } = softwares;

    return (
      <div className="booker-success">
        <span className="booker-success__user">
          Hi {business.info.FIRST_NAME || business.info.EMAIL}
        </span>
        <p className="booker-success__message">{requestStatusMessage}</p>
        <div className="booker-success__actions">
          <button
            type="button"
            className="btn btn--primary btn--lg no-margin"
            onClick={onDone}
          >
            OK
          </button>
        </div>
      </div>
    );
  }
}

BookerSetupSuccess.propTypes = {
  onDone: PropTypes.func.isRequired,
  getTextNumber: PropTypes.func.isRequired,
  softwares: PropTypes.shape().isRequired,
  business: PropTypes.shape().isRequired,
};
